import { DEFAULT_SEAT_COLORS, SEAT_STATE_COLORS } from '../constants/colors';

export const buildPriceColorMap = (uniquePrices: number[]) => {
  const map = new Map<number, string>();
  uniquePrices.forEach((price, index) => {
    map.set(price, DEFAULT_SEAT_COLORS[index % DEFAULT_SEAT_COLORS.length]);
  });
  return map;
};

export const getSeatFillColor = (
  isAvailable: boolean,
  isHighlighted: boolean,
  baseColor: string
) => {
  if (!isAvailable) {
    return SEAT_STATE_COLORS.BOOKED;
  }

  return isHighlighted ? baseColor : `${baseColor}4D`;
};

export const getSelectedStrokeColor = (baseColor: string) => {
  const normalized = baseColor.startsWith('#') ? baseColor.slice(1) : baseColor;
  const rgb = normalized.length === 3 ? normalized.split('').map(char => char + char).join('') : normalized;
  const r = Math.min(255, Math.round(parseInt(rgb.slice(0, 2), 16) * 0.7));
  const g = Math.min(255, Math.round(parseInt(rgb.slice(2, 4), 16) * 0.7));
  const b = Math.min(255, Math.round(parseInt(rgb.slice(4, 6), 16) * 0.7));
  return (r << 16) + (g << 8) + b;
};
